import * as ActionTypes from 'app/common/constants/action-types';
import { loadUser, removeSession } from 'app/common/helpers/auth';

export const loadAuth = () => dispatch => {
  dispatch({
    type: ActionTypes.USER_REQUEST,
  });

  return loadUser()
    .then(user =>
      dispatch({
        type: ActionTypes.USER_SUCCESS,
        user,
      })
    )
    .catch(err => {
      dispatch({
        type: ActionTypes.USER_FAILURE,
        error: err,
      });
    });
};

// remove sessionStorage
export const signOut = () => {
  removeSession();
  return {
    type: ActionTypes.USER_SIGNOUT,
  };
};
